/**
 * Build default column definitions for PersonalizeDataGrid from list config.
 */
export function buildListPersonalizeColumns(config = {}, extraKeys = []) {
  const {
    defaultVisibleColumns = [],
    columnLabels = {},
    columnWidths = {},
    pinnedColumns = [],
    mandatoryColumns = [],
  } = config;

  const allKeys = [
    ...new Set([
      ...defaultVisibleColumns,
      ...Object.keys(columnLabels),
      ...(Array.isArray(extraKeys) ? extraKeys : []),
    ]),
  ];

  return allKeys.map((key, index) => {
    const visibleIndex = defaultVisibleColumns.indexOf(key);
    const autoLabel = key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return {
      key,
      field: key,
      label: columnLabels[key] || autoLabel,
      width: columnWidths[key] || 150,
      visible:
        visibleIndex >= 0 ||
        (defaultVisibleColumns.length === 0 && index < 5),
      pinned: pinnedColumns.includes(key) ? "left" : undefined,
      required: mandatoryColumns.includes(key),
      order: visibleIndex >= 0 ? visibleIndex : index,
    };
  });
}
